"use client";

import { locales, localeNames } from "@/i18n/config";
import { useLocale } from "@/i18n/LocaleProvider";
import { cn, Menu } from "@/components/ui";

export default function LocaleSwitcher() {
  const { locale, setLocale } = useLocale();

  return (
    <Menu
      value={locale}
      onChange={setLocale}
      options={locales.map((l) => ({ value: l, label: localeNames[l] }))}
      trigger={({ open }) => (
        <button
          type="button"
          aria-label="Language"
          className={cn(
            "inline-flex h-9 items-center gap-1.5 whitespace-nowrap rounded-lg border border-border bg-surface px-3 text-xs font-medium text-foreground transition-colors hover:bg-surface-muted",
            open && "border-accent/50 ring-2 ring-[color:var(--ring)]/30"
          )}
        >
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-muted"
          >
            <circle cx="12" cy="12" r="9" />
            <path d="M3 12h18M12 3c2.5 2.6 4 6 4 9s-1.5 6.4-4 9c-2.5-2.6-4-6-4-9s1.5-6.4 4-9Z" />
          </svg>
          {localeNames[locale]}
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={cn("text-muted transition-transform", open && "rotate-180")}
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </button>
      )}
    />
  );
}
